import React from "react"
import { Pagination, PaginationItem, PaginationLink } from "reactstrap"

const BlogPagination = ({ pages }) => {
  const pageNumbers = []
  for (let i = 1; i <= pages; i++) {
    pageNumbers.push(i)
  }
  return (
    <Pagination aria-label="Page navigation example">
      {pageNumbers.map((number) => (
        <PaginationItem key={number}>
          <PaginationLink href={number !== 1 ? `/blog/${number}` : "/blog"}>{number}</PaginationLink>
        </PaginationItem>
      ))}
    </Pagination>
  )
}
export default BlogPagination
